<div class="p-6 pb-3">

  <!-- Tabs + Refresh -->
  <div class="hidden sm:flex sm:items-center sm:justify-between mb-6">
    <nav class="flex space-x-4" aria-label="Tabs">
      <a (click)="switchTab('prospecting')" class="cursor-pointer rounded-md px-3 py-2 text-sm font-medium"
         [ngClass]="activeTab === 'prospecting' ? 'text-violet-500 bg-violet-50' : 'text-secondary hover:opacity-90'">
        Advanced Prospecting
      </a>
      <a (click)="switchTab('reports')" class="cursor-pointer rounded-md px-3 py-2 text-sm font-medium"
         [ngClass]="activeTab === 'reports' ? 'text-violet-500 bg-violet-50' : 'text-secondary hover:opacity-90'">
        Reports
      </a>
      <a (click)="switchTab('leads')" class="cursor-pointer rounded-md px-3 py-2 text-sm font-medium"
         [ngClass]="activeTab === 'leads' ? 'text-violet-500 bg-violet-50' : 'text-secondary hover:opacity-90'">
        Leads
      </a>
    </nav>

    <!-- Refresh Button -->
    <button
      (click)="refreshExports()"
      class="btn bg-gray-50 dark:bg-primary-200 text-secondary text-sm hover:opacity-90"
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
      </svg>
    </button>
  </div>

  <div class="sm:hidden flex items-center justify-between mb-6">
    <div class="flex-1 mr-3">
      <label for="export-tabs" class="sr-only">Select a tab</label>
      <select id="export-tabs" name="export-tabs" [(ngModel)]="activeTab" (change)="onTabSelectChange()" class="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm">
        <option value="prospecting">Advanced Prospecting</option>
        <option value="reports">Reports</option>
        <option value="leads">Leads</option>
      </select>
    </div>
    <button
      (click)="refreshExports()"
      class="btn bg-gray-50 dark:bg-primary-200 text-secondary text-sm hover:opacity-90"
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
        <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
      </svg>
    </button>
  </div>

  <!-- ============================================ -->
  <!-- TAB 1: Advanced Prospecting (Veridion) -->
  <!-- ============================================ -->
  <ng-container *ngIf="activeTab === 'prospecting'">

    <!-- Error State -->
    <div *ngIf="(error$ | async) as error" class="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4">
      <p class="font-semibold">Error:</p>
      <p>{{ error }}</p>
      <button
        (click)="refreshExports()"
        class="mt-2 text-sm text-red-600 hover:text-red-800 underline"
      >
        Try Again
      </button>
    </div>

    <!-- Exports Table -->
    <ng-container *ngIf="!(error$ | async)">
      <ng-container *ngIf="{ exports: exports$ | async, downloadingIds: downloadingIds$ | async, loading: loading$ | async } as data">

        <!-- Table Container with Border -->
        <div class="rounded-xl border border-gray-200 overflow-hidden relative">

          <!-- Table with data -->
          <div *ngIf="data.exports && data.exports.length > 0" class="overflow-x-auto">
            <table class="min-w-full divide-y divide-gray-200">
              <!-- Header -->
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="py-3.5 pr-3 pl-4 text-left text-sm font-semibold text-gray-700 sm:pl-6">
                    Export ID
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700">
                    Status
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700">
                    Records
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700">
                    Credits Used
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700">
                    Created
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700">
                    Completed
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700 w-32">
                    Actions
                  </th>
                </tr>
              </thead>
              <!-- Table Body -->
              <tbody class="divide-y divide-gray-200 bg-white">
                <tr *ngFor="let export of data.exports; last as isLast" class="hover:bg-gray-50" [class.border-b-0]="isLast">
                  <td class="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-6">
                    #{{ export.id }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap">
                    <span
                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                      [class]="getStatusClass(export.status)"
                    >
                      {{ getStatusLabel(export.status) }}
                    </span>
                  </td>
                  <td class="px-3 py-4 text-sm whitespace-nowrap text-gray-500">
                    <div class="flex flex-col">
                      <span>{{ export.total_records | number:'1.0-0' }} records</span>
                      <span class="text-xs text-gray-400">{{ export.pages_completed }}/{{ export.total_pages }} pages ({{ export.progress_percentage }}%)</span>
                    </div>
                  </td>
                  <td class="px-3 py-4 text-sm whitespace-nowrap text-gray-500">
                    {{ export.credits_used | number:'1.0-0' }}
                  </td>
                  <td class="px-3 py-4 text-sm whitespace-nowrap text-gray-500">
                    {{ export.created_at | date:'short' }}
                  </td>
                  <td class="px-3 py-4 text-sm whitespace-nowrap text-gray-500">
                    {{ export.completed_at ? (export.completed_at | date:'short') : '-' }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap w-32">
                    <button
                      (click)="downloadExport(export)"
                      [disabled]="export.status !== 'completed' || isDownloading(export.id, data.downloadingIds || [])"
                      class="inline-flex items-center px-3 py-1.5 rounded-lg text-xs font-medium focus:outline-none transition-all"
                      [ngClass]="{
                        'bg-primary text-white hover:opacity-90': export.status === 'completed' && !isDownloading(export.id, data.downloadingIds || []),
                        'bg-gray-100 text-gray-400 cursor-not-allowed': export.status !== 'completed',
                        'bg-primary/50 text-white cursor-wait': export.status === 'completed' && isDownloading(export.id, data.downloadingIds || [])
                      }"
                      [title]="export.status !== 'completed' ? 'Export is ' + export.status : ''"
                    >
                      <!-- Loading spinner when downloading -->
                      <svg
                        *ngIf="isDownloading(export.id, data.downloadingIds || [])"
                        class="animate-spin h-3 w-3 mr-1"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      <!-- Download icon -->
                      <svg
                        *ngIf="!isDownloading(export.id, data.downloadingIds || [])"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        class="h-3 w-3 mr-1"
                        [ngClass]="export.status === 'completed' ? 'text-white' : 'text-gray-500'"
                      >
                        <path d="M10.75 2.75a.75.75 0 0 0-1.5 0v8.614L6.295 8.235a.75.75 0 1 0-1.09 1.03l4.25 4.5a.75.75 0 0 0 1.09 0l4.25-4.5a.75.75 0 0 0-1.09-1.03l-2.955 3.129V2.75Z" />
                        <path d="M3.5 12.75a.75.75 0 0 0-1.5 0v2.5A2.75 2.75 0 0 0 4.75 18h10.5A2.75 2.75 0 0 0 18 15.25v-2.5a.75.75 0 0 0-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5Z" />
                      </svg>
                      <span [ngClass]="export.status === 'completed' ? 'text-white' : 'text-gray-500'">{{ isDownloading(export.id, data.downloadingIds || []) ? 'Downloading...' : 'Download' }}</span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Loading Overlay (shown on top of table when refreshing) -->
          <div *ngIf="data.loading && data.exports && data.exports.length > 0" class="absolute inset-0 flex items-center justify-center bg-white/80">
            <svg class="animate-spin h-6 w-6 text-blue-royal" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </div>

          <!-- Initial Loading State (no data yet) -->
          <div *ngIf="data.loading && (!data.exports || data.exports.length === 0)" class="flex items-center justify-center bg-white py-12">
            <svg class="animate-spin h-6 w-6 text-blue-royal" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </div>

          <!-- Empty State -->
          <div *ngIf="!data.loading && (!data.exports || data.exports.length === 0)" class="flex items-center justify-center bg-white py-12">
            <div class="text-center">
              <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-gray-100 mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="h-6 w-6 text-gray-400">
                  <path d="M10.75 2.75a.75.75 0 0 0-1.5 0v8.614L6.295 8.235a.75.75 0 1 0-1.09 1.03l4.25 4.5a.75.75 0 0 0 1.09 0l4.25-4.5a.75.75 0 0 0-1.09-1.03l-2.955 3.129V2.75Z" />
                  <path d="M3.5 12.75a.75.75 0 0 0-1.5 0v2.5A2.75 2.75 0 0 0 4.75 18h10.5A2.75 2.75 0 0 0 18 15.25v-2.5a.75.75 0 0 0-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5Z" />
                </svg>
              </div>
              <h3 class="text-sm font-medium text-gray-900">No exports found</h3>
              <p class="mt-1 text-sm text-gray-500">You haven't created any exports yet.</p>
              <a
                routerLink="/advanced-search"
                class="mt-4 inline-flex items-center px-3 py-2 text-sm font-medium text-primary hover:text-primary/80"
              >
                Go to Advanced Search
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4 ml-1">
                  <path fill-rule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z" clip-rule="evenodd" />
                </svg>
              </a>
            </div>
          </div>

        </div>

        <!-- Pagination -->
        <div *ngIf="data.exports && data.exports.length > 0 && (pagination$ | async) as pagination" class="mt-3 flex items-center justify-between bg-white dark:bg-indigo-custom">
          <div class="flex flex-1 justify-between sm:hidden">
            <button
              (click)="onPageChange(pagination.current_page - 1)"
              [disabled]="pagination.current_page <= 1"
              [class.opacity-50]="pagination.current_page <= 1"
              [class.cursor-not-allowed]="pagination.current_page <= 1"
              class="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
            >
              Previous
            </button>
            <button
              (click)="onPageChange(pagination.current_page + 1)"
              [disabled]="pagination.current_page >= pagination.last_page"
              [class.opacity-50]="pagination.current_page >= pagination.last_page"
              [class.cursor-not-allowed]="pagination.current_page >= pagination.last_page"
              class="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
            >
              Next
            </button>
          </div>
          <div class="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
            <div>
              <p class="text-sm text-gray-700">
                Showing page
                <span class="font-medium">{{ pagination.current_page }}</span>
                of
                <span class="font-medium">{{ pagination.last_page }}</span>
                (<span class="font-medium">{{ pagination.total | number:'1.0-0' }}</span> total exports)
              </p>
            </div>
            <div>
              <nav class="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
                <button
                  (click)="onPageChange(pagination.current_page - 1)"
                  [disabled]="pagination.current_page <= 1"
                  [class.opacity-50]="pagination.current_page <= 1"
                  [class.cursor-not-allowed]="pagination.current_page <= 1"
                  class="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                >
                  <span class="sr-only">Previous</span>
                  <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z" clip-rule="evenodd" />
                  </svg>
                </button>

                <button
                  *ngFor="let page of getPaginationPages(pagination)"
                  (click)="onPageChange(page)"
                  [class.bg-primary]="page === pagination.current_page"
                  [class.text-white]="page === pagination.current_page"
                  [class.text-gray-900]="page !== pagination.current_page"
                  class="relative inline-flex items-center px-4 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                >
                  {{ page }}
                </button>

                <button
                  (click)="onPageChange(pagination.current_page + 1)"
                  [disabled]="pagination.current_page >= pagination.last_page"
                  [class.opacity-50]="pagination.current_page >= pagination.last_page"
                  [class.cursor-not-allowed]="pagination.current_page >= pagination.last_page"
                  class="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                >
                  <span class="sr-only">Next</span>
                  <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clip-rule="evenodd" />
                  </svg>
                </button>
              </nav>
            </div>
          </div>
        </div>

      </ng-container>
    </ng-container>

  </ng-container>

  <!-- ============================================ -->
  <!-- TAB 2: Reports (Search Export) -->
  <!-- ============================================ -->
  <ng-container *ngIf="activeTab === 'reports'">

    <!-- Error State -->
    <div *ngIf="(searchExportsError$ | async) as error" class="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4">
      <p class="font-semibold">Error:</p>
      <p>{{ error }}</p>
      <button
        (click)="refreshExports()"
        class="mt-2 text-sm text-red-600 hover:text-red-800 underline"
      >
        Try Again
      </button>
    </div>

    <!-- Search Exports Table -->
    <ng-container *ngIf="!(searchExportsError$ | async)">
      <ng-container *ngIf="{ exports: searchExports$ | async, downloadingIds: searchExportDownloadingIds$ | async, loading: searchExportsLoading$ | async } as data">

        <!-- Table Container with Border -->
        <div class="rounded-xl border border-gray-200 overflow-hidden relative">

          <!-- Table with data -->
          <div *ngIf="data.exports && data.exports.length > 0" class="overflow-x-auto">
            <table class="min-w-full divide-y divide-gray-200">
              <!-- Header -->
              <thead class="bg-gray-50">
                <tr>
                  <th scope="col" class="py-3.5 pr-3 pl-4 text-left text-sm font-semibold text-gray-700 sm:pl-6">
                    Export ID
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700">
                    Status
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700">
                    Records
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700">
                    File Size
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700">
                    Created
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700">
                    Completed
                  </th>
                  <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700 w-32">
                    Actions
                  </th>
                </tr>
              </thead>
              <!-- Table Body -->
              <tbody class="divide-y divide-gray-200 bg-white">
                <tr *ngFor="let export of data.exports; last as isLast" class="hover:bg-gray-50" [class.border-b-0]="isLast">
                  <td class="py-4 pr-3 pl-4 text-sm font-medium whitespace-nowrap text-gray-900 sm:pl-6">
                    #{{ export.id }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap">
                    <span
                      class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
                      [class]="getStatusClass(export.status)"
                    >
                      {{ getStatusLabel(export.status) }}
                    </span>
                  </td>
                  <td class="px-3 py-4 text-sm whitespace-nowrap text-gray-500">
                    <div class="flex flex-col">
                      <span>{{ export.total_records | number:'1.0-0' }} records</span>
                      <span class="text-xs text-gray-400">{{ export.pages_completed }}/{{ export.total_pages }} pages ({{ export.progress_percentage }}%)</span>
                    </div>
                  </td>
                  <td class="px-3 py-4 text-sm whitespace-nowrap text-gray-500">
                    {{ export.file_size_formatted || '-' }}
                  </td>
                  <td class="px-3 py-4 text-sm whitespace-nowrap text-gray-500">
                    {{ export.created_at | date:'short' }}
                  </td>
                  <td class="px-3 py-4 text-sm whitespace-nowrap text-gray-500">
                    {{ export.completed_at ? (export.completed_at | date:'short') : '-' }}
                  </td>
                  <td class="px-3 py-4 whitespace-nowrap w-32">
                    <button
                      (click)="downloadSearchExport(export)"
                      [disabled]="export.status !== 'completed' || isSearchExportDownloading(export.id, data.downloadingIds || [])"
                      class="inline-flex items-center px-3 py-1.5 rounded-lg text-xs font-medium focus:outline-none transition-all"
                      [ngClass]="{
                        'bg-primary text-white hover:opacity-90': export.status === 'completed' && !isSearchExportDownloading(export.id, data.downloadingIds || []),
                        'bg-gray-100 text-gray-400 cursor-not-allowed': export.status !== 'completed',
                        'bg-primary/50 text-white cursor-wait': export.status === 'completed' && isSearchExportDownloading(export.id, data.downloadingIds || [])
                      }"
                      [title]="export.status !== 'completed' ? 'Export is ' + export.status : ''"
                    >
                      <!-- Loading spinner when downloading -->
                      <svg
                        *ngIf="isSearchExportDownloading(export.id, data.downloadingIds || [])"
                        class="animate-spin h-3 w-3 mr-1"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      <!-- Download icon -->
                      <svg
                        *ngIf="!isSearchExportDownloading(export.id, data.downloadingIds || [])"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        class="h-3 w-3 mr-1"
                        [ngClass]="export.status === 'completed' ? 'text-white' : 'text-gray-500'"
                      >
                        <path d="M10.75 2.75a.75.75 0 0 0-1.5 0v8.614L6.295 8.235a.75.75 0 1 0-1.09 1.03l4.25 4.5a.75.75 0 0 0 1.09 0l4.25-4.5a.75.75 0 0 0-1.09-1.03l-2.955 3.129V2.75Z" />
                        <path d="M3.5 12.75a.75.75 0 0 0-1.5 0v2.5A2.75 2.75 0 0 0 4.75 18h10.5A2.75 2.75 0 0 0 18 15.25v-2.5a.75.75 0 0 0-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5Z" />
                      </svg>
                      <span [ngClass]="export.status === 'completed' ? 'text-white' : 'text-gray-500'">{{ isSearchExportDownloading(export.id, data.downloadingIds || []) ? 'Downloading...' : 'Download' }}</span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Loading Overlay (shown on top of table when refreshing) -->
          <div *ngIf="data.loading && data.exports && data.exports.length > 0" class="absolute inset-0 flex items-center justify-center bg-white/80">
            <svg class="animate-spin h-6 w-6 text-blue-royal" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </div>

          <!-- Initial Loading State (no data yet) -->
          <div *ngIf="data.loading && (!data.exports || data.exports.length === 0)" class="flex items-center justify-center bg-white py-12">
            <svg class="animate-spin h-6 w-6 text-blue-royal" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </div>

          <!-- Empty State -->
          <div *ngIf="!data.loading && (!data.exports || data.exports.length === 0)" class="flex items-center justify-center bg-white py-12">
            <div class="text-center">
              <div class="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-gray-100 mb-4">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="h-6 w-6 text-gray-400">
                  <path d="M10.75 2.75a.75.75 0 0 0-1.5 0v8.614L6.295 8.235a.75.75 0 1 0-1.09 1.03l4.25 4.5a.75.75 0 0 0 1.09 0l4.25-4.5a.75.75 0 0 0-1.09-1.03l-2.955 3.129V2.75Z" />
                  <path d="M3.5 12.75a.75.75 0 0 0-1.5 0v2.5A2.75 2.75 0 0 0 4.75 18h10.5A2.75 2.75 0 0 0 18 15.25v-2.5a.75.75 0 0 0-1.5 0v2.5c0 .69-.56 1.25-1.25 1.25H4.75c-.69 0-1.25-.56-1.25-1.25v-2.5Z" />
                </svg>
              </div>
              <h3 class="text-sm font-medium text-gray-900">No report exports found</h3>
              <p class="mt-1 text-sm text-gray-500">Export your reports from the Reports page to see them here.</p>
              <a
                routerLink="/reports"
                class="mt-4 inline-flex items-center px-3 py-2 text-sm font-medium text-primary hover:text-primary/80"
              >
                Go to Reports
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" class="w-4 h-4 ml-1">
                  <path fill-rule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.23 5.29a.75.75 0 111.04-1.08l5.5 5.25a.75.75 0 010 1.08l-5.5 5.25a.75.75 0 11-1.04-1.08l4.158-3.96H3.75A.75.75 0 013 10z" clip-rule="evenodd" />
                </svg>
              </a>
            </div>
          </div>

        </div>

        <!-- Pagination -->
        <div *ngIf="data.exports && data.exports.length > 0 && (searchExportsPagination$ | async) as pagination" class="mt-3 flex items-center justify-between bg-white dark:bg-indigo-custom">
          <div class="flex flex-1 justify-between sm:hidden">
            <button
              (click)="onSearchExportPageChange(pagination.current_page - 1)"
              [disabled]="pagination.current_page <= 1"
              [class.opacity-50]="pagination.current_page <= 1"
              [class.cursor-not-allowed]="pagination.current_page <= 1"
              class="relative inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
            >
              Previous
            </button>
            <button
              (click)="onSearchExportPageChange(pagination.current_page + 1)"
              [disabled]="pagination.current_page >= pagination.last_page"
              [class.opacity-50]="pagination.current_page >= pagination.last_page"
              [class.cursor-not-allowed]="pagination.current_page >= pagination.last_page"
              class="relative ml-3 inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
            >
              Next
            </button>
          </div>
          <div class="hidden sm:flex sm:flex-1 sm:items-center sm:justify-between">
            <div>
              <p class="text-sm text-gray-700">
                Showing page
                <span class="font-medium">{{ pagination.current_page }}</span>
                of
                <span class="font-medium">{{ pagination.last_page }}</span>
                (<span class="font-medium">{{ pagination.total | number:'1.0-0' }}</span> total exports)
              </p>
            </div>
            <div>
              <nav class="isolate inline-flex -space-x-px rounded-md shadow-sm" aria-label="Pagination">
                <button
                  (click)="onSearchExportPageChange(pagination.current_page - 1)"
                  [disabled]="pagination.current_page <= 1"
                  [class.opacity-50]="pagination.current_page <= 1"
                  [class.cursor-not-allowed]="pagination.current_page <= 1"
                  class="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                >
                  <span class="sr-only">Previous</span>
                  <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z" clip-rule="evenodd" />
                  </svg>
                </button>

                <button
                  *ngFor="let page of getPaginationPages(pagination)"
                  (click)="onSearchExportPageChange(page)"
                  [class.bg-primary]="page === pagination.current_page"
                  [class.text-white]="page === pagination.current_page"
                  [class.text-gray-900]="page !== pagination.current_page"
                  class="relative inline-flex items-center px-4 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                >
                  {{ page }}
                </button>

                <button
                  (click)="onSearchExportPageChange(pagination.current_page + 1)"
                  [disabled]="pagination.current_page >= pagination.last_page"
                  [class.opacity-50]="pagination.current_page >= pagination.last_page"
                  [class.cursor-not-allowed]="pagination.current_page >= pagination.last_page"
                  class="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
                >
                  <span class="sr-only">Next</span>
                  <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fill-rule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clip-rule="evenodd" />
                  </svg>
                </button>
              </nav>
            </div>
          </div>
        </div>

      </ng-container>
    </ng-container>

  </ng-container>


  <!-- ============================================ -->
  <!-- TAB 3: Leads (prospecting list → Excel) -->
  <!-- ============================================ -->
  <ng-container *ngIf="activeTab === 'leads'">

    <div *ngIf="leadExportsError" class="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4">
      <p>{{ leadExportsError }}</p>
      <button (click)="loadLeadExports()" class="mt-2 text-sm text-red-600 hover:text-red-800 underline">Try Again</button>
    </div>

    <div *ngIf="!leadExportsError" class="rounded-xl border border-gray-200 overflow-hidden relative">
      <div *ngIf="leadExports.length > 0" class="overflow-x-auto">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-gray-50">
            <tr>
              <th scope="col" class="py-3.5 pr-3 pl-4 text-left text-sm font-semibold text-gray-700 sm:pl-6">List</th>
              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700">Status</th>
              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700">Leads</th>
              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700">Emails</th>
              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700">Credits Used</th>
              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700">Created</th>
              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-700 w-32">Actions</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200 bg-white">
            <tr *ngFor="let exp of leadExports" class="hover:bg-gray-50">
              <td class="py-4 pr-3 pl-4 text-sm text-gray-900 sm:pl-6 max-w-xs">
                <span class="block truncate font-medium" [title]="exp.summary_label || ''">{{ exp.summary_label || ('Export #' + exp.id) }}</span>
                <span class="block text-xs text-gray-400">{{ exp.companies_processed | number }}/{{ exp.pool_total ?? '—' }} companies</span>
                <span *ngIf="(exp.part ?? 1) > 1" class="block text-xs text-gray-500">Part {{ exp.part }} · after {{ (exp.lead_offset ?? 0) | number }} leads</span>
              </td>
              <td class="px-3 py-4 whitespace-nowrap">
                <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium" [class]="getStatusClass(exp.status)">
                  {{ getLeadExportStatusLabel(exp) }}
                </span>
                <div *ngIf="isLeadExportActive(exp)" class="mt-1.5 w-28 h-1.5 rounded-full bg-gray-100 overflow-hidden">
                  <div class="h-full bg-violet-500 transition-all duration-500" [style.width.%]="exp.progress_percentage || 0"></div>
                </div>
              </td>
              <td class="px-3 py-4 text-sm whitespace-nowrap text-gray-500">
                {{ exp.leads_found | number }} / {{ exp.requested_mode === 'all' ? 'all' : (exp.requested_count | number) }}
              </td>
              <td class="px-3 py-4 text-sm whitespace-nowrap text-gray-500">
                {{ exp.include_emails ? (exp.emails_found | number) : '—' }}
              </td>
              <td class="px-3 py-4 text-sm whitespace-nowrap text-gray-500">{{ exp.credits_used | number:'1.0-0' }}</td>
              <td class="px-3 py-4 text-sm whitespace-nowrap text-gray-500">{{ exp.created_at | date:'short' }}</td>
              <td class="px-3 py-4 whitespace-nowrap w-32">
                <div *ngIf="exp.stop_reason === 'insufficient_credits'" class="text-xs mb-1.5" [class.text-amber-700]="!exp.continued_by_id" [class.text-gray-400]="exp.continued_by_id">
                  Out of credits{{ exp.continued_by_id ? ' · continued' : '' }}
                </div>
                <button *ngIf="exp.can_continue" type="button" (click)="continuingLeadExport = exp"
                        [disabled]="hasActiveLeadExport"
                        [title]="hasActiveLeadExport ? 'Wait for the running export to finish' : 'Continue where it stopped'"
                        class="inline-flex items-center gap-1 px-3 py-1.5 mr-1.5 rounded-lg text-xs font-medium bg-violet-600 text-white hover:bg-violet-700 disabled:opacity-50">
                  Continue
                </button>
                <button *ngIf="exp.is_downloadable || !exp.can_continue" (click)="downloadLeadExport(exp)"
                        [disabled]="!exp.is_downloadable || leadExportDownloadingIds.has(exp.id)"
                        class="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs font-medium focus:outline-none transition-all"
                        [ngClass]="exp.is_downloadable ? 'bg-primary text-white hover:opacity-90' : 'bg-gray-100 text-gray-400 cursor-not-allowed'"
                        [title]="exp.is_downloadable ? (exp.file_size_formatted || '') : 'Export is ' + getLeadExportStatusLabel(exp).toLowerCase()">
                  <svg *ngIf="leadExportDownloadingIds.has(exp.id)" class="animate-spin h-3 w-3" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                  </svg>
                  {{ leadExportDownloadingIds.has(exp.id) ? 'Downloading...' : 'Download' }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div *ngIf="leadExportsLoading && leadExports.length > 0" class="absolute inset-0 flex items-center justify-center bg-white/80">
        <svg class="animate-spin h-6 w-6 text-blue-royal" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
        </svg>
      </div>

      <div *ngIf="(leadExportsLoading || !leadExportsLoaded) && leadExports.length === 0" class="flex items-center justify-center bg-white py-12">
        <svg class="animate-spin h-6 w-6 text-blue-royal" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
        </svg>
      </div>

      <div *ngIf="!leadExportsLoading && leadExportsLoaded && leadExports.length === 0" class="flex items-center justify-center bg-white py-12">
        <div class="text-center">
          <h3 class="text-sm font-medium text-gray-900">No lead exports yet</h3>
          <p class="mt-1 text-sm text-gray-500">Use "Proceed to Leads" on an Advanced Prospecting search, then "Export to Excel".</p>
          <a routerLink="/advanced-search" class="mt-4 inline-flex items-center px-3 py-2 text-sm font-medium text-primary hover:text-primary/80">
            Go to Advanced Search
          </a>
        </div>
      </div>
    </div>

    <div *ngIf="leadExports.length > 0 && leadExportsPagination.last_page > 1" class="mt-3 flex items-center justify-between">
      <p class="text-sm text-gray-700">
        Page <span class="font-medium">{{ leadExportsPagination.current_page }}</span> of
        <span class="font-medium">{{ leadExportsPagination.last_page }}</span>
        (<span class="font-medium">{{ leadExportsPagination.total | number:'1.0-0' }}</span> total exports)
      </p>
      <div class="flex gap-2">
        <button (click)="onLeadExportsPageChange(leadExportsPagination.current_page - 1)"
                [disabled]="leadExportsPagination.current_page <= 1"
                class="rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-50">
          Previous
        </button>
        <button (click)="onLeadExportsPageChange(leadExportsPagination.current_page + 1)"
                [disabled]="leadExportsPagination.current_page >= leadExportsPagination.last_page"
                class="rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm text-gray-700 hover:bg-gray-50 disabled:opacity-50">
          Next
        </button>
      </div>
    </div>
  </ng-container>

</div>

<app-continue-export-dialog
  *ngIf="continuingLeadExport"
  [exp]="continuingLeadExport"
  (started)="onLeadExportContinued()"
  (closed)="continuingLeadExport = null"
></app-continue-export-dialog>
